module.exports = __webpack_public_path__ + "img/logo.64e7bc42.png";